import { PLATFROM_REG } from './platform';

let navigator;

if (typeof window !== 'undefined') {
  navigator = window.navigator;
}

/**
 * 客户端检测
 */
export const uaInfo = {
  userAgent: navigator?.userAgent.toLowerCase(),
  isH5: Boolean(navigator?.userAgent.match(PLATFROM_REG.H5)),
  isAndroid: Boolean(navigator?.userAgent.match(PLATFROM_REG.Android)),
  isIOS: !!navigator?.userAgent.match(PLATFROM_REG.IOS),
  isIphone: Boolean(navigator?.userAgent.match(PLATFROM_REG.Iphone)),
  isIpad: Boolean(navigator?.userAgent.match(PLATFROM_REG.Ipad)),
  isWeixin: Boolean(navigator?.userAgent.match(PLATFROM_REG.Weixin)),
  isWorkWeixin: Boolean(navigator?.userAgent.match(PLATFROM_REG.WorkWeixin)),
  isQQBrowser: Boolean(navigator?.userAgent.match(PLATFROM_REG.QQBrowser)),
  isQQInsideBrowser: navigator?.userAgent.match(/qq/gi) && navigator?.userAgent.match(/qqtheme/gi),
  isDingtalk: Boolean(navigator?.userAgent.match(PLATFROM_REG.Dingtalk)),
  isInstagram: Boolean(navigator?.userAgent.match(PLATFROM_REG.Instagram)),
  isFacebook: Boolean(navigator?.userAgent.match(PLATFROM_REG.Facebook)),
  isInTalkie: Boolean(navigator?.userAgent.match(PLATFROM_REG.InTalkie)),
  IsSearchEngine: Boolean(navigator?.userAgent.match(PLATFROM_REG.IsSearchEngine)),
  isSafari: Boolean(navigator?.userAgent.match(PLATFROM_REG.Safari)),
  isMac: Boolean(navigator?.userAgent.match(PLATFROM_REG.Mac)),
};

export default {
  uaInfo,
};
